import React, { useState, Fragment, useRef, useEffect } from "react";
import useKeyboardShortcuts from "../../../../hooks/KeysHandle/useKeyboardShortcuts";
import { ReactComponent as SearchBarIMG } from "../../../../assets/images/searchBarIMG.svg";
import { Tooltip } from "@mui/material";
import SearchIcon from "../../../../assets/images/icons/SearchIcon";

const SearchBar = ({ data, event, tableDetail, SearchOpen = false, InputClass }) => {
  const [tableSearch, setTableSearch] = useState(SearchOpen);
  const [isHovered, setIsHovered] = useState(false);
  const inputRef = useRef(null);

  const TableSearchData = () => {
    setTableSearch(!tableSearch);
  };

  useEffect(() => {
    if (!tableSearch) {
      setIsHovered(false);
    }
  }, [tableSearch]);

  useEffect(() => {
    const storedData = localStorage.getItem(`search-${tableDetail.tableHeading}`);
    if (storedData) {
      setTableSearch(true);
    }
  }, []);

  useKeyboardShortcuts({
    ToggleSearchBar: (event) => {
      event.preventDefault();
      TableSearchData();
    },
  });

  useEffect(() => {
    if (tableSearch && inputRef.current) {
      inputRef.current.focus();
    }
  }, [tableSearch]);

  return (
    <Fragment>
      {tableSearch && (
        <div className="relative flex items-center">
          <input
            ref={inputRef}
            className={`px-3 pr-7 ${InputClass} rounded border-[#1D4469] text-12 border w-full not-italic mb-1`}
            type="text"
            value={data}
            onChange={(e) => {
              event(e?.target?.value);
            }}
            placeholder="Search"
            style={{
              outline: "none",
              boxShadow: "none",
              border: "1px solid #1D4469",
              borderRadius: "4px",
            }}
          />

          {data?.length > 0 && (
            <button onClick={() => event("")} className="absolute right-2 top-1/2 transform -translate-y-1/2">
              <i className="bi bi-x cursor-pointer text-gray-400"></i>
            </button>
          )}

          {/* <div className="absolute left-3">
           
            <SearchBarIMG />
          </div> */}
        </div>
      )}

      {/* <Tooltip placement="top" title="Search"> */}
      <Tooltip
        placement="top"
        title="Search"
        PopperProps={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "black",
              color: "white",
              boxShadow: "none",
              height: "23px",
              display: "flex",
              alignItems: "center",
            },
          },
        }}
      >
        <button
          type="button"
          onClick={TableSearchData}
          className={`tooltip hover:text-254155 pb-1.5 ${tableSearch ? "" : "px-1 text-2541558A"}`}
        >
          {/* <i className={`bi bi-search tableheaderfiltericon `}></i> */}
          <SearchIcon isHovered={isHovered} isActive={tableSearch} />
          {/* <span className={`tooltiptext text-[10px] w-[60px] bottom-full left-1/2 ml-[-30px]`}>Search</span> */}
        </button>
      </Tooltip>
    </Fragment>
  );
};

export default SearchBar;
